import type { CalendarDate } from '@internationalized/date';
import type { RangeValue } from '@react-types/shared';
import { RangeCalendar } from '@heroui/react';

interface HeroUiRangeCalendarGridProps {
  ariaLabel: string;
  value: RangeValue<CalendarDate> | null;
  onChange: (value: RangeValue<CalendarDate>) => void;
  minValue?: CalendarDate;
  maxValue?: CalendarDate;
  className?: string;
  fullWidth?: boolean;
}

export function HeroUiRangeCalendarGrid({
  ariaLabel,
  value,
  onChange,
  minValue,
  maxValue,
  className,
  fullWidth = false,
}: HeroUiRangeCalendarGridProps) {
  return (
    <RangeCalendar
      aria-label={ariaLabel}
      className={fullWidth ? `!w-full !max-w-none ${className ?? ''}`.trim() : (className ?? 'w-full')}
      value={value ?? undefined}
      onChange={onChange}
      minValue={minValue}
      maxValue={maxValue}
    >
      <RangeCalendar.Header>
        <RangeCalendar.YearPickerTrigger>
          <RangeCalendar.YearPickerTriggerHeading />
          <RangeCalendar.YearPickerTriggerIndicator />
        </RangeCalendar.YearPickerTrigger>
        <RangeCalendar.NavButton slot="previous" />
        <RangeCalendar.NavButton slot="next" />
      </RangeCalendar.Header>
      <RangeCalendar.Grid>
        <RangeCalendar.GridHeader>
          {(day) => <RangeCalendar.HeaderCell>{day}</RangeCalendar.HeaderCell>}
        </RangeCalendar.GridHeader>
        <RangeCalendar.GridBody>{(date) => <RangeCalendar.Cell date={date} />}</RangeCalendar.GridBody>
      </RangeCalendar.Grid>
      <RangeCalendar.YearPickerGrid>
        <RangeCalendar.YearPickerGridBody>
          {({ year }) => <RangeCalendar.YearPickerCell year={year} />}
        </RangeCalendar.YearPickerGridBody>
      </RangeCalendar.YearPickerGrid>
    </RangeCalendar>
  );
}
